export default "$radius-1: .4rem\n$radius-2: .6rem\n$radius-3: .8rem\n$radius-4: 1.2rem\n$radius-5: 1.6rem\n$radius-round: 19042014px\n";